import { Step } from '../../types';

/**
 * Strategy interface for step definition
 * Each step implements this to provide its configuration
 */
export interface StepDefinitionStrategy {
  /**
   * Returns the step definition with translated content
   */
  getStepDefinition(): Step;
}
